import { render } from "./template.vue?vue&type=template&id=6b71ac22&scoped=true&lang=pug"
const script = {}

import "./template.vue?vue&type=style&index=0&id=6b71ac22&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b71ac22"]])

export default __exports__